import { Typography, useTheme } from '@mui/material';

export const ComposerFormatToggleIcon = ({ isExpanded }: { isExpanded: boolean }) => {
  const theme = useTheme();
  return (
    <Typography
      component="span"
      color="inherit"
      sx={{
        fontSize: '0.8125rem',
        fontWeight: 500,
        lineHeight: 1,
        // the Button root's uppercase transform would render "Aa" as "AA"
        textTransform: 'none',
        // currentColor so the underline follows note mode's amber override
        borderBottom: `0.09375rem solid ${
          isExpanded ? theme.palette.primary.light : 'currentColor'
        }`,
      }}
    >
      Aa
    </Typography>
  );
};
